import { Env } from '../../utils/util.js';
import wxshare from './wx_share.js';
import COVERAPP from './COVERAPP.js';
console.log('COVERAPP');
console.log(COVERAPP);

let cglogo = 'https://cbgccdn.thecover.cn/cdn/cbgc/static/img/logo.png';
function share(item){
  console.log('share item:', item);
  if(Env.isWeixin()){
    var shareData = {
      title: item.title,
      desc: item.content.content || item.content, 
      link: item.link || location.href.split('#')[0], 
      imgUrl: item.imgUrl || cglogo, 
      success: function () {
          // 用户确认分享后执行的回调函数
      },
      cancel: function () {
          // 用户取消分享后执行的回调函数
      }
    }
    console.log('shareData:', shareData);
    loadScript('https://res.wx.qq.com/open/js/jweixin-1.2.0.js').then(res=>{
      wxshare(shareData);
    }).catch(err=>{console.log(err)});
  }else if(Env.isCGApp()){
    COVERAPP.Method.Share({
      'title': item.title,
      'link': item.link || location.href.split('#')[0],
      'imgUrl': item.imgUrl || cglogo,
      'desc': item.content.content || item.content || '',
      'origin': ''
    });
  } else if(Env.isQQ()){
    loadScript('https://qzonestyle.gtimg.cn/qzone/qzact/common/share/share.js').then(res=>{
      setShareInfo({
        title: item.title,
        summary: item.content.content || item.content || '',
        pic: item.imgUrl || cglogo,
        url: item.link || location.href.split('#')[0] 
      })
    }).catch(err=>err);
  }
  
}

function loadScript(src) {
  return new Promise(function(resolve, reject){
    var script = document.createElement('script'),
      head = document.getElementsByTagName('head')[0];
    script.type = 'text/javascript';
    script.charset = 'UTF-8';
    script.src = src;
    if (script.addEventListener) {
      script.addEventListener('load', function () {
        resolve(1);
      }, false);
    } else if (script.attachEvent) {
      script.attachEvent('onreadystatechange', function () {
        var target = window.event.srcElement;
        target.readyState == 'loaded' ? resolve(1) : reject(0);
      });
    }
    head.appendChild(script);
  });
}
export {
  share
}